import { Injectable } from '@angular/core';
import { Api, User } from '../'

@Injectable()
export class Schedule {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) {
    return this.api.get('index.php/marketing/schedule', params);
  }

  getActivity(params?: any) {
    return this.api.get('index.php/marketing/activity', params);
  }

  delete(params?: any) {
    return this.api.post('index.php/marketing/schedule/delSchedule', params);
  }

  post(params?: any) {
    if(params.id==''){
      params.created_by = this.user.data.employee_id;
    }else{
      params.updated_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/marketing/schedule', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/marketing/schedule/schedule.ts